import { useTranslation } from "react-i18next";

export default function LegalPage({
  title,
  updated,
  intro,
  sectionKeys,
  i18nRoot,
  testIdRoot,
  footer,
}) {
  const { t } = useTranslation();
  return (
    <section className="py-14 sm:py-20">
      <div className="max-w-[860px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="eyebrow" data-testid={`${testIdRoot}-eyebrow`}>
          {updated}
        </div>
        <h1
          className="mt-3 font-display text-3xl sm:text-5xl tracking-[-0.01em] text-foreground"
          data-testid={`${testIdRoot}-title`}
        >
          {title}
        </h1>
        <p className="mt-6 text-base sm:text-[1.02rem] text-foreground/90 leading-relaxed">
          {intro}
        </p>

        <div className="mt-10 space-y-8">
          {sectionKeys.map((k) => (
            <div key={k} data-testid={`${testIdRoot}-section-${k}`}>
              <h2 className="font-display text-2xl tracking-[-0.01em] text-foreground">
                {t(`${i18nRoot}.${k}.title`)}
              </h2>
              <p className="mt-3 text-[0.98rem] text-foreground/90 leading-relaxed">
                {t(`${i18nRoot}.${k}.body`)}
              </p>
            </div>
          ))}
        </div>

        {footer && <div className="mt-12">{footer}</div>}
      </div>
    </section>
  );
}
